export default (() => {
    let sidebarServices = $('.sidebar-wrapper .single-service.active');
    if(sidebarServices.length == 0) {
        sidebarServices = $('.sidebar-wrapper .single-service:first-child')
        sidebarServices.addClass('active')
    }
    let others = sidebarServices.siblings('.single-service')

    if ($(window).outerWidth() < 1023) {
        console.log(others)
        others.wrapAll('<div class="wrapper-services-inner">')
    }

    sidebarServices.on('click', function (e) {
        e.preventDefault()
        if ($(window).outerWidth() > 1023) return;
        $('.wrapper-services-inner').slideToggle()
    })  

    let sidebar = $('.sidebar .widget_nav_menu .menu-item-has-children');

    sidebar.on('click', function (event) {
        const menu = $(this).children('.sub-menu');
        console.log(event.target, event.target.nodeType)
        if (!$(event.target).is('a')) {
            $(this).toggleClass('active')
            menu.stop().slideToggle()
        }
    })

    

    let sidebarInvestor = $('.sidebar-with-title .sidebar .widget-title')


        sidebarInvestor.each(function() {
        const sidebarMenu = $(this).siblings('div')
        const activeSidebarElement = sidebarMenu.find('.current-menu-item').text()
            if(activeSidebarElement != '') {
                sidebarMenu.toggleClass('desktop-active')
                $(this).addClass('highlighted')
                const elementToHide = sidebarMenu.find('.current-menu-item')
            }
        })

    sidebarInvestor.on('click', function (){
        const menu = $(this).siblings('div')
        menu.toggleClass('active')
        $(this).toggleClass('active')
        menu.stop().slideToggle()

    })

})($)


// WEBPACK FOOTER //
// ./scripts/layout/sidebars.js